import { useEffect, useContext } from 'react'

import Cookies from 'js-cookie'

import { useNavigate } from 'react-router-dom'

import Ct from '../Ct'

const Logout = () => {

  const navigate = useNavigate()

  const { updfun } = useContext(Ct)

  useEffect(() => {

    // ✅ REMOVE COOKIE
    Cookies.remove('logincrd')
    localStorage.removeItem("cartItems")

    // ✅ UPDATE CONTEXT
    updfun(false)

    // ✅ SMALL DELAY
    setTimeout(() => {

      navigate('/login')

    }, 100)

  }, [])

  return (

    <div className="auth-page auth-message-page">
      <div className="auth-card auth-mini-card">
        <span className="auth-kicker">
          Signing Out
        </span>

        <h2>
          Logging out...
        </h2>
      </div>

    </div>
  )
}

export default Logout
